import { IBasketHeaderModel, BasketHeaderModel } from './basket-header-model'
import { IBasketContentModel, BasketContentModel } from './basket-content-model'

//IMPORTANT: this file is auto-generated, any changes included will not be persisted, if extension is required please inherit from this class in separate file and inlcude your changes there

export interface IBasketModel { 
       header?: IBasketHeaderModel;
       content?: IBasketContentModel[];
}

export class BasketModel implements IBasketModel {
    constructor(
        public header: BasketHeaderModel,
        public content: BasketContentModel[]
    )
    {

    }

    public static empty() {
        return new BasketModel(null, null);
    }
}


